import { axios } from "@/client/libs/axios";

export type Mood = "casual" | "professional" | "confident" | "friendly";

export const changeTone = async (text: string, mood: Mood) => {
  const response = await axios.post<{ text: string }>("/ai/change-tone", { text, mood });

  return response.data.text;
};
